import classNames from '@sindresorhus/class-names';
import localFont from 'next/font/local';

export const vkFont = localFont({
  src: [
    {
      weight: '400',
      path: '../../public/fonts/VKSansDisplay-Regular.woff2',
    },
    {
      weight: '500',
      path: '../../public/fonts/VKSansDisplay-Medium.woff2',
    },
    {
      weight: '600',
      path: '../../public/fonts/VKSansDisplay-DemiBold.woff2',
    },
    {
      weight: '700',
      path: '../../public/fonts/VKSansDisplay-Bold.woff2',
    },
  ],
  display: 'swap',
  variable: '--vk-font',
  fallback: ['arial', 'system-ui', 'sans-serif'],
});

export const vkFontClassNames = classNames(vkFont.className, vkFont.variable);
